<template>    
    <div v-if="item && item.quantity_per_box" class="product-filters-container">
        <div class="product-single-filter" style="flex-direction: column; align-items: start">
            <c-label>Unidade:</c-label><br>
            <grid-size>
                <ul style="margin-bottom: 0.5rem">
                    <li
                        v-for="(un, key) in conversionUnits"
                        :key="key"
                        :class="{ 'active-size': un.active }"
                        @click="setConversionUnit(un)"
                    >
                        <span>{{ un.label }}</span>
                    </li>
                </ul>
            </grid-size>
            <c-span v-if="conversionUnitWhenSellingWithClosedBox == 'CX'">
                <strong>
                    {{ numberOfBoxesSelected }} {{ numberOfBoxesSelected > 1 ? 'caixas' : 'caixa' }} são {{ item.quantity_per_box * numberOfBoxesSelected }} unidades.
                </strong>
            </c-span>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { CLabel, CSpan } from '../Styles/Components/styled'
import { CGridSize } from '../Styles/Product/styled'

export default {
    name: 'ProductOptionsConversionUnity',
    props: {
        item: {
            required: true
        },
    },
    components: {
        'c-label': CLabel,
        'c-span': CSpan,
        'grid-size': CGridSize,
    },
    data() {
        return {
            conversionUnits: [
                { label: 'UND', active: true },
                { label: 'CX', active: false },
            ]
        }
    },
    methods: {
        ...mapActions("products", [
            "setConversionUnitWhenSellingWithClosedBox"
        ]),
        setConversionUnit(un) {
            this.activeConversionUnit(un)
            this.setConversionUnitWhenSellingWithClosedBox(un.label)
        },
        activeConversionUnit(un) {
            this.conversionUnits.map(el => el.active = false)
            un.active = true
        }
    },
    watch: {
        conversionUnitWhenSellingWithClosedBox(value) {
            this.activeConversionUnit(this.conversionUnits.find(el => el.label == value))
        }
    },
    computed: {
        ...mapState("products", [
            "numberOfBoxesSelected",
            "conversionUnitWhenSellingWithClosedBox"
        ])
    }
}
</script>

<style scoped>
ul {
    display: flex;
}
</style>